import { Observable, OperatorFunction, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

interface TakeUntilDestroyInternal {
    new (...args: any[]): {};

    _onTakeUntilDestroy?: Subject<void>;
}

function createSubject(self: TakeUntilDestroyInternal): void {
    if (!self._onTakeUntilDestroy) {
        self._onTakeUntilDestroy = new Subject<void>();
    }
}

export function takeUntilDestroy<T>(that: any): OperatorFunction<T, T> {
    const self = that as TakeUntilDestroyInternal;
    createSubject(self);
    return (source: Observable<T>): Observable<T> => {
        return source.pipe(takeUntil(self._onTakeUntilDestroy));
    };
}

export function TakeUntilDestroy() {
    return function <T extends TakeUntilDestroyInternal>(constructor: T) {
        const origNgOnDestroy = constructor.prototype.ngOnDestroy;
        constructor.prototype.ngOnDestroy = function () {
            if (this._onTakeUntilDestroy) {
                this._onTakeUntilDestroy.next();
                this._onTakeUntilDestroy.complete();
                this._onTakeUntilDestroy = null;
            }
            origNgOnDestroy?.apply(this);
        };
    };
}
